<template>
    <div class="dropdown-menu notifications-dropdown"  id="notifications-dropdown" aria-labelledby="notifications-dropdown-menu">
        <section :class="[ 'notifications-section body', { 'center': status !== 'ready' } ]">
            <notification-item v-for="notification in undismissedNotifications" :key="notification.Id"
                :Title="__('Title', notification)"
                :Description="__('Description', notification)"
                :Url="notification.Url"
                :CreatedAt="notification.CreatedAt"
                :Severity="notification.Severity"
                :HasBeenRead="notification.HasBeenRead"
                :HasBeenDismissed="notification.HasBeenDismissed"
                @click="viewNotification(notification.Id)"
                @dismiss="dismissNotification(notification.Id)"
            ></notification-item>
            <p class="no-notifications" v-if="status === 'ready' && !undismissedNotifications.length"><i class="fas fa-smile"></i>You don't have any notifications yet!</p>
            <p class="loading" v-if="status === 'loading'"><i class="fas fa-circle-notch fa-spin"></i></p>
            <button class="retry" v-if="status === 'error'" @click="init()"><i class="fas fa-exclamation-triangle"></i>Retry</button>
        </section>
    </div>
</template>
<script>
import NotificationItem from "@/components/dashboard/NotificationItem";
import NotificationsService from "@/services/NotificationsService";
import $ from 'jquery';

export default {
    name: "notifications-dropdown",
    components: {
        NotificationItem
    },
    data() {
        return {
            status: "loading",
            notifications: [],
            notificationsInterval: 60 * 1000 // 10 Minutes
        }
    },
    mounted() {
        this.init();
        this.disableCloseOnDismiss();
    },
    methods: {
        async init() {
            this.fetchNotifications();
            setInterval(() => {
                this.fetchNotificationsWithoutLoading();
            }, this.notificationsInterval);
        },
        async fetchNotifications() {
            this.status = "loading";
            try {
                let response = await NotificationsService.getUserNotifications();
                this.notifications = response.data;
                this.status = "ready";
            } catch(e) {
                this.status = "error";
                this.notifications = [];
            }
        },
        async fetchNotificationsWithoutLoading() {
            try {
                let response = await NotificationsService.getUserNotifications();
                this.notifications = response.data;
                this.$store.commit("notifications/setNumberOfNotifications", this.notifications.length);
            } catch(e) {
                this.$store.commit("notifications/setNumberOfNotifications", 0);
            } 
        },
        async viewNotification(notificationId) {
            try {
                let index = this.notifications.findIndex(notification => { return notification.Id === notificationId; });
                this.notifications[index].HasBeenRead = true;
                //await NotificationsService.markAsRead(notificationId);
            } catch(e) {}
            this.$store.commit("notifications/openNotificationsPopup", notificationId);
        },
        async dismissNotification(notificationId) {
            try {
                await NotificationsService.dismissNotification(notificationId);
                let index = this.notifications.findIndex(notification => { return notification.Id === notificationId; });
                this.notifications.splice(index, 1);
            } catch(e) {
            }
        },
        disableCloseOnDismiss() {
            $('#notifications-dropdown').on('click', function (e) {
                let name = $(e.target).attr('data-name');
                if(name === "HasBeenDismissed")
                    e.stopPropagation();
            });
        },
        updateCounter() {
            this.$store.commit("notifications/setNumberOfNotifications", this.numberOfUnreadNotifications);
        }
    },
    computed: {
        undismissedNotifications() {
            return this.notifications.filter(notification => {
                return notification.HasBeenDismissed === false;
            });
        },
        numberOfUnreadNotifications() {
            return this.undismissedNotifications.filter(notification => {
                return notification.HasBeenRead === false;
            }).length;
        }
    },
    watch: {
        undismissedNotifications() {
            this.updateCounter();
        },
        numberOfUnreadNotifications() {
            this.updateCounter();
        }
    }
}
</script>
